import { Button, SVG } from "ui";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";

export type IndirectModalProps = GeneralModalProps & CustomComponentProps;

const IndirectModal = ({
    open,
    setOpen,
    className,
    style
}: IndirectModalProps) => {
    return (
        <div
            className={`incdident-rules-modal modal share-modal is-xsmall has-light-bg ${open ? "is-active" : ""} ${className}`}
            style={style}
        >
            <div
                className="modal-background"
                onClick={() => setOpen(false)}
            ></div>
            <div className="modal-content">
                <div className="card">
                    <div className="card-heading flex-a-center flex-j-center flex-col gap-10">
                        <div className="blue-large-circle">
                            <SVG
                                svg="curved-arrow"
                                size={30}
                                className="white-svg"
                            />
                        </div>
                        <h3 className="fw-700 fs-100">Indirect Followers</h3>
                    </div>

                    <div className="card-body">
                        <div className="rules-desc momeento-p fw-500 text-center">
                            There's indirect followers who have exact matches of
                            Languages and Topics which you are interested
                        </div>
                    </div>

                    <div className="card-footer">
                        <div className="button-wrap d-flex flex-j-center w-full">
                            <Button
                                text="ok"
                                handleClick={() => setOpen(false)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IndirectModal;
